import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {
  static targets = [
    "streetInput",
    "neighborhoodInput",
    "cityInput",
    "stateInput",
    "numberInput",
  ];

  postalCodeChanged(event) {
    const cep = event.target.value;
    if (cep.length != "9") {
      return;
    }

    fetch(`https://viacep.com.br/ws/${cep}/json`)
      .then((response) => response.json())
      .then((data) => {
        if (!data.erro) {
          this.populateData(data);
          this.numberInputTarget.focus();
        }
      });
  }

  populateData(data) {
    this.streetInputTarget.value = data.logradouro;
    this.neighborhoodInputTarget.value = data.bairro;
    this.cityInputTarget.value = data.localidade;
    this.stateInputTarget.value = data.uf;
  }
}
